/**
 * Derive the batch number from a lot/serial name. Serials are `<batch>-<bag>`; a lot name is
 * the batch itself. Splits on the LAST hyphen so a batch containing hyphens still works as long
 * as the bag number doesn't. Mirrors the Worker's `batchOfLotName`.
 */
export function batchOfLotName(name: string): string {
  const i = name.lastIndexOf("-");
  return i > 0 ? name.slice(0, i) : name;
}
